"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createRequirementGalaDinnerInfoItem = exports.createPromoBadge = exports.createMoldovaResidentsInfoItem = exports.createAdditionalPaymentInfoItem = exports.combineOfferPrices = void 0;
var _ramda = require("ramda");
var _static = require("@otpusk/json-api/dist/static");
var _localization = _interopRequireDefault(require("../../../../../../localization"));
var _Badge = require("../../../../../ui/Badge");
var _styles = _interopRequireDefault(require("./styles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var createPromoBadge = exports.createPromoBadge = function createPromoBadge(isHeightPromo, promoText) {
  return !!promoText && {
    className: _styles.default.promo,
    color: isHeightPromo ? _Badge.COLORS.GREEN : _Badge.COLORS.YELLOW,
    children: '%',
    tooltipContent: promoText
  };
};
var createAdditionalPaymentInfoItem = exports.createAdditionalPaymentInfoItem = function createAdditionalPaymentInfoItem(additionalPayments) {
  return !(0, _ramda.isEmpty)(additionalPayments) && {
    content: (0, _ramda.join)(' ', additionalPayments)
  };
};
var createMoldovaResidentsInfoItem = exports.createMoldovaResidentsInfoItem = function createMoldovaResidentsInfoItem(includesOptions) {
  return (0, _ramda.includes)('moldova', includesOptions) && {
    content: _localization.default.t('TOUR_OPTIONS:MOLDOVA_RESIDENTS')
  };
};
var createRequirementGalaDinnerInfoItem = exports.createRequirementGalaDinnerInfoItem = function createRequirementGalaDinnerInfoItem(requirementOptions) {
  return (0, _ramda.includes)(_static.TOUR_OPTIONS.GALA_DINNER, requirementOptions) && {
    content: _localization.default.t('TOUR_OPTIONS:REQUIREMENT_GALA_DINNER')
  };
};
var combineOfferPrices = exports.combineOfferPrices = function combineOfferPrices(originalPrice, recalculatedPrice, totalPriceOfBookingServices) {
  return recalculatedPrice || originalPrice + totalPriceOfBookingServices;
};